import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetCustomSiteEventChartData, GetCustomSiteEventChartDataResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetCustomSiteEventChartDataResponse, GetCustomSiteEventChartDataResponse>) => response?.data
const getError = (response?: SWRResponse<GetCustomSiteEventChartDataResponse, GetCustomSiteEventChartDataResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetCustomSiteEventChartDataResponse, GetCustomSiteEventChartDataResponse>) => ({});

const useGetCustomSiteEventChartData = (query?: Partial<GetCustomSiteEventChartData>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetCustomSiteEventChartData(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetCustomSiteEventChartData;